const LOGOS = {
    ARBITRIP: 'https://s3.amazonaws.com/arbitrip/logos/arbitrip_logo.png',
    LETSTAY: 'https://arbitrip.s3.us-east-1.amazonaws.com/theme/letstay/logo.svg',
    HTZ: 'https://i.imgur.com/bBrfEPu.png',
    ELAL: 'https://elal-assets.s3.eu-central-1.amazonaws.com/elal_travel_logo.png',
    ISRACARD: 'https://isracard-assets.s3.eu-central-1.amazonaws.com/isracard_header_logo.svg',
    AIRHAIFA: 'https://airhaifa-assets.s3.eu-central-1.amazonaws.com/airhaifa-app-logo.svg',
};

module.exports = {
    LOGOS,
};
